import { useEffect, useState } from 'react';

export const useIsUserTabbing = () => {
  const [userIsTabbing, setUserIsTabbing] = useState(false);

  const handleFirstTab = (event: KeyboardEvent) => {
    if (event.key === 'Tab') {
      setUserIsTabbing(true);
      window.removeEventListener('keydown', handleFirstTab);
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', handleFirstTab);
    return () => {
      window.removeEventListener('keydown', handleFirstTab);
    };
  });

  return userIsTabbing;
};
